import { Api } from "./base";

const _headers = () => {
  return {
    Authorization:
      "JWT " + require("store").default.getState().onboard.user.auth_token,
    "Content-Type": "application/json",
  };
};

export default {
  //.......................................Listing Quiz ........................................
  getPassagesList(grade, offset) {
    return Api.getCsv(
      `/cmfluency/v1/admin-passages/?offset=${offset}&grade=${grade}`,
      _headers()
    );
  },
  getPassageById(quizId) {
    return Api.get(`/cmfluency/v1/admin-passages/${quizId}/`, _headers());
  },

  updatePassage(passageId, data) {
    return Api.put(
      `/cmfluency/v1/admin-passages/${passageId}/`,
      data,
      _headers()
    );
  },
};
